import React from 'react';
import { Link } from 'react-router-dom';
import { CheckCircle, Mail } from 'lucide-react';

const BusinessApplicationSubmitted = () => {
  return (
    <div className="container" style={{ maxWidth: '600px', paddingTop: '100px', textAlign: 'center' }}>
      <div className="card">
        <CheckCircle size={64} color="#4CAF50" style={{ margin: '0 auto 24px' }} />

        <h1 style={{ marginBottom: '16px', fontSize: '28px' }}>
          Thank You for Applying!
        </h1>

        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px', marginBottom: '24px' }}>
          <Mail size={20} color="var(--textSecondary)" />
          <p className="text-muted" style={{ margin: 0 }}>
            Check your email for confirmation
          </p>
        </div>

        <div style={{
          background: '#f8f9fa',
          border: '2px solid var(--border)',
          borderRadius: 'var(--radius-md)',
          padding: '24px',
          marginBottom: '24px',
          textAlign: 'left',
        }}>
          <h3 style={{ marginBottom: '12px', fontSize: '18px' }}>What happens next?</h3>
          <ul style={{ marginBottom: 0, paddingLeft: '20px', lineHeight: 1.8 }}>
            <li>Our team will review your business account application</li>
            <li>You'll receive an email notification within <strong>1-3 business days</strong></li>
            <li>If approved, you'll gain access to bulk listing tools and store pickup options</li>
            <li>We may contact you if we need additional information</li>
          </ul>
        </div>

        <p className="text-muted" style={{ marginBottom: '24px' }}>
          In the meantime, you can log in and start exploring the marketplace!
        </p>

        <div style={{ display: 'flex', gap: '12px', justifyContent: 'center' }}>
          <Link to="/login" className="btn btn-primary">
            Log In to Your Account
          </Link>
          <Link to="/" className="btn" style={{ background: 'var(--cardBackground)', border: '2px solid var(--border)' }}>
            Browse Marketplace
          </Link>
        </div>
      </div>
    </div>
  );
};

export default BusinessApplicationSubmitted;
